'use client';

import { useMemo } from 'react';

import { useBehaviorSubject } from '@ps/functions/hooks/useBehaviorSubject';

import type { ClientChatMessage } from '../types/ChatMessage';
import { useGlobalChatContext } from './useGlobalChat';

/**
 * Subset of the global pending-messages subject scoped to one room
 * (matches by `roomId`). Used by the per-room message context to
 * splice in-flight messages into the visible history.
 */
export function usePendingMessages(roomId: string): ClientChatMessage[] {
  const { pendingMessages$ } = useGlobalChatContext();
  const [pendingMessages] = useBehaviorSubject(pendingMessages$);
  return useMemo(
    () => pendingMessages.filter(x => x.roomId === roomId),
    [pendingMessages, roomId],
  );
}
